import React from 'react'
import { useNavigate } from 'react-router-dom'
import Navbar from '../components/Navbar'
import noimage from "../images/notfound.png"
import styles from '../styles/error.module.css'

function Error() {
  const navigate = useNavigate()
  return (
    <div className={styles.error}>
      <div className={styles.e}>
        <div className={styles.errorIcon}>🔍</div>
        <img src={noimage} className={styles.error_img} alt="Page not found" />
        <h2 className={styles.errorTitle}>Oops! Page Not Found</h2>
        <p className={styles.errorMessage}>The page you're looking for doesn't exist or has been moved. Let's get you back on track!</p>
        <button className={styles.gobacktohome} onClick={() => { navigate("/") }}>
          🏠 Go Home
        </button>
      </div>
    </div>
  )
}

export default Error